import { summaryTableStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsSummaryTable";
import { css } from "styled-components";

summaryTableStyles.orderLines = {
    gridContainer: {
        gap: 10,
        css: css`
            .card_container__wrapper {
                border-top: none;
            }
            .card_container__wrapper ~ .card_container__wrapper {
                border-top: none;
            }
        `,
    },
    productInfoQtyOrderedHeadingAndText: {
        extendedStyles: {
            wrapper: {
                css: css`
                    padding-right: 10px;
                `,
            },
            heading: {
                variant: "legend",
                weight: "bold",
            },

            text: {
                css: css`
                    text-align: center;
                    color: #205c40 !important;
                    @media print {
                        text-align: left;
                    }
                `,
            },
        },
    },
    productInfoQtyShippedHeadingAndText: {
        extendedStyles: {
            wrapper: {
                css: css`
                    padding-right: 10px;
                `,
            },
            heading: {
                variant: "legend",
                weight: "bold",
            },

            text: {
                css: css`
                    text-align: center;
                    color: #205c40 !important;
                    @media print {
                        text-align: left;
                    }
                `,
            },
        },
    },
    subtotalWithoutVatHeadingAndText: {
        text: {
            css: css`
                text-align: center;
                color: #205c40 !important;
                @media print {
                    text-align: left;
                }
            `,
        },
    },
    productInfoSubtotalHeadingAndText: {
        wrapper: {
            css: css`
                padding-right: 10px;
            `,
        },
        heading: {
            variant: "legend",
            weight: "bold",
        },

        text: {
            weight: "bold",
            css: css`
                color: #205c40 !important;
                text-align: center;
                @media print {
                    text-align: left;
                }
            `,
        },
    },
    priceHeadingAndText: {
        extendedStyles: {
            heading: {
                weight: "bold",
            },
            text: {
                weight: "bold",
                css: css`
                    color: #205c40 !important;
                `,
            },
        },
    },
};
